import styles from "./SliderItem.module.scss";
import { ISubscription } from "../../../models/Subscription";
import React from "react";
import { useTranslation } from "react-i18next";

interface ISliderItemProps {
  item: ISubscription;
  index: number;
  activeIndex: number;
}

const SliderItem: React.FC<ISliderItemProps> = ({ item, index, activeIndex }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.item} ${index === activeIndex && styles.active}`}>
      <h3 className={styles.price}>
        {item.price}€ <span>/ {t("Month")}</span>
      </h3>
      <p className={styles.sessions}>
        {item.credits} {t("Sessions")}
      </p>
    </div>
  );
};

export default SliderItem;
